// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "tabs-3bDXy";
var _3 = "tab-T_7_M";
var _4 = "label-xGA9K";
var _5 = "description-10Gql";
var _6 = "underline-zEG8p";
var _7 = "line-21Zzw";
var _8 = "lineInvert-2xZsp";
export { _1 as "__esModule", _2 as "tabs", _3 as "tab", _4 as "label", _5 as "description", _6 as "underline", _7 as "line", _8 as "lineInvert" }
export default { "__esModule": _1, "tabs": _2, "tab": _3, "label": _4, "description": _5, "underline": _6, "line": _7, "lineInvert": _8 }
